import { api } from './api';

export const physicalLocationsService = {
  getLocations: async () => {
    const { data } = await api.get('/physical-locations');
    return data;
  },

  getTree: async () => {
    const { data } = await api.get('/physical-locations/tree');
    return data;
  },

  findById: async (id: string) => {
    const { data } = await api.get(`/physical-locations/${id}`);
    return data;
  },

  createLocation: async (locationData: any) => {
    const { data } = await api.post('/physical-locations', locationData);
    return data;
  },

  deleteLocation: async (id: string) => {
    const { data } = await api.delete(`/physical-locations/${id}`);
    return data;
  }
};
